import { NewsFilters, news } from '@api/api/news';
import { getTimeTillEndOfDayMs } from '@helpers/utils/dates/getTimeTillEndOfDayMs';
import { useQuery } from '@tanstack/react-query';
import { QUERY_NEWS_FILTERS } from '@terminal/services/news/news-service';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

export const useNewsFilters = () =>
  useQuery({
    queryKey: [QUERY_NEWS_FILTERS],
    queryFn: ({ signal }) =>
      wretchRequest<NewsFilters>(news.filtersV4.path, {
        method: 'get',
        signal,
      }),
    select: res => res ?? [],
    staleTime: getTimeTillEndOfDayMs(),
  });
